var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgItems(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "items",
    transform: "translate(-1512 -87)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2034",
    "data-name": "Rect\\xE1ngulo 2034",
    width: 26,
    height: 26,
    transform: "translate(1512 87)",
    fill: "#fff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    transform: "translate(1513.466 91)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-Set-Filled"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bullet-list",
    d: "M592.477,223.523H579.75a1.591,1.591,0,0,0,0,3.182h12.727a1.591,1.591,0,0,0,0-3.182Zm0-6.364H579.75a1.591,1.591,0,0,0,0,3.182h12.727a1.591,1.591,0,0,0,0-3.182Zm-12.727-3.182h12.727a1.591,1.591,0,0,0,0-3.182H579.75a1.591,1.591,0,0,0,0,3.182Zm-6.364,8.75a2.386,2.386,0,1,0,2.386,2.386,2.386,2.386,0,0,0-2.386-2.386Zm0-6.364a2.386,2.386,0,1,0,2.386,2.386,2.386,2.386,0,0,0-2.386-2.386Zm0-6.364a2.386,2.386,0,1,0,2.386,2.386A2.386,2.386,0,0,0,573.386,210Z",
    transform: "translate(-571 -210)",
    fill: "#777",
    fillRule: "evenodd"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItems);
export default __webpack_public_path__ + "static/media/items.770235df0a4de0a3adddc1dc634002f2.svg";
export { ForwardRef as ReactComponent };